<template>
  <Layout>
    <div
      style="display:flex;justify-content:center;margin-top:20px;font-size:14px"
    >
      <div class="row" style="width:700px">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="card-body-form">
                <div v-if="allModify" class="page-transparent-bg"></div>
                <div
                  style="text-align:center;width:100%;font-size:20px;font-weight:bold;margin-bottom:20px"
                >
                  汉新闻媒体号注册
                </div>
                <!-- <b-form> -->
                <label style="margin-top:18px" for="media-name"
                  ><span must>*</span>媒体号名称</label
                >
                <b-form-input
                  v-model="media.name"
                  :state="validate_name"
                  id="media-name"
                  @blur="validateName"
                  @input="validateName"
                  style="width:360px"
                  placeholder="请输入"
                ></b-form-input>
                <b-form-invalid-feedback v-show="validate_name === false">
                  必填项，2-16个字符
                </b-form-invalid-feedback>
                <!-- <b-form-valid-feedback :state="validation">
                    Looks Good.
                  </b-form-valid-feedback> -->
                <label style="margin-top:18px" for="media-phone"
                  ><span must>*</span>手机号</label
                >
                <b-form-input
                  v-model="media.phone"
                  :state="validate_phone"
                  id="media-phone"
                  @blur="validatePhone"
                  @input="validatePhone"
                  style="width:360px"
                  placeholder="请输入"
                  autocomplete="never"
                ></b-form-input>
                <b-form-invalid-feedback v-show="validate_phone === false">
                  {{ media.phone ? " 请输入合法的手机号" : "必填项" }}
                </b-form-invalid-feedback>

                <label style="margin-top:18px" for="media-password"
                  ><span must>*</span>密码</label
                >
                <b-form-input
                  v-model="media.password"
                  :state="validate_password"
                  id="media-password"
                  @input="validatePassword"
                  style="width:200px"
                  placeholder="请输入"
                  type="password"
                ></b-form-input>
                <b-form-invalid-feedback v-show="validate_password === false">
                  {{ passwordWarning }}
                </b-form-invalid-feedback>

                <label style="margin-top:18px" for="media-repeatPassword"
                  ><span must>*</span>确认密码</label
                >
                <b-form-input
                  v-model="media.repeatPassword"
                  :state="validate_repeatPassword"
                  id="media-repeatPassword"
                  @blur="validateRepeatPassword"
                  @input="validateRepeatPassword"
                  style="width:200px"
                  placeholder="请输入"
                  type="password"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-show="validate_repeatPassword === false"
                >
                  {{ repeatPasswordWarning }}
                </b-form-invalid-feedback>

                <label style="margin-top:18px" for="media-cerName"
                  ><span must>*</span>认证名称</label
                >
                <b-form-input
                  v-model="media.cerName"
                  :state="validate_cerName"
                  id="media-cerName"
                  @blur="validateCerName"
                  @input="validateCerName"
                  style="width:360px"
                  placeholder="请输入"
                ></b-form-input>
                <b-form-invalid-feedback v-show="validate_cerName === false">
                  必填项
                </b-form-invalid-feedback>

                <label style="margin-top:18px" for="media-description"
                  ><span must>*</span>媒体号简介</label
                >
                <!-- <b-form-input
                  v-model="media.description"
                  :state="validate_description"
                  id="media-description"
                  @blur="validateDescription"
                  @input="validateDescription"
                  style="width:360px"
                  placeholder="请输入"
                ></b-form-input> -->
                <b-form-textarea
                  v-model="media.description"
                  :state="validate_description"
                  id="media-description"
                  @blur="validateDescription"
                  @input="validateDescription"
                  style="width:360px;padding-right:10px"
                  placeholder="请输入"
                  rows="3"
                ></b-form-textarea>
                <b-form-invalid-feedback
                  v-show="validate_description === false"
                >
                  必填项
                </b-form-invalid-feedback>

                <label style="margin-top:18px" for="media-operateBody"
                  ><span must>*</span>运营主体/姓名</label
                >
                <b-form-input
                  v-model="media.operateBody"
                  :state="validate_operateBody"
                  id="media-operateBody"
                  @blur="validateOperateBody"
                  @input="validateOperateBody"
                  style="width:360px"
                  placeholder="请输入"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-show="validate_operateBody === false"
                >
                  必填项
                </b-form-invalid-feedback>

                <label style="margin-top:18px" for="media-creditCode"
                  ><span must>*</span>统一社会信用代码/身份证号</label
                >
                <b-form-input
                  v-model="media.creditCode"
                  :state="validate_creditCode"
                  id="media-creditCode"
                  @blur="validateCreditCode"
                  @input="validateCreditCode"
                  style="width:360px"
                  placeholder="请输入"
                ></b-form-input>
                <b-form-invalid-feedback v-show="validate_creditCode === false">
                  必填项
                </b-form-invalid-feedback>

                <!-- <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>账号类型</label>
                      <div>
                        <el-radio v-model="media.type" :label="1"
                          >汉新闻号</el-radio
                        >
                        <el-radio v-model="media.type" :label="2"
                          >记者/供稿单位</el-radio
                        >
                        <el-radio v-model="media.type" :label="3"
                          >广电矩阵</el-radio
                        >
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label style="margin-top:18px"
                        ><span must>*</span>认证类型</label
                      >
                      <div>
                        <el-radio v-model="media.cerType" :label="1"
                          >个人</el-radio
                        >
                        <el-radio v-model="media.cerType" :label="2"
                          >企业</el-radio
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>免审开关</label>
                    <div>
                      <el-radio v-model="media.verifyFlag" :label="0"
                        >关闭</el-radio
                      >
                      <el-radio v-model="media.verifyFlag" :label="1"
                        >开启</el-radio
                      >
                    </div>
                  </div>
                </div>
              </div> -->

                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label><span must>*</span>头像</label>
                      <image-upload
                        size="1:1"
                        ref="avatar"
                        v-model="media.avatar"
                        :edit="false"
                      ></image-upload>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 1:1，建议尺寸 200 * 200 px
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-9">
                    <div class="mb-3">
                      <label><span must>*</span>认证材料上传</label>
                      <div style="display: flex">
                        <div>
                          <image-upload
                            size="1:1"
                            v-model="img1"
                            :edit="false"
                          ></image-upload>
                        </div>
                        <div style="margin-left: 10px">
                          <image-upload
                            size="1:1"
                            v-model="img2"
                            :edit="false"
                          ></image-upload>
                        </div>
                        <div style="margin-left: 10px">
                          <image-upload
                            size="1:1"
                            v-model="img3"
                            :edit="false"
                          ></image-upload>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                    style="color: #aaa; margin-top: 5px;word-break:break-all;overflow-x:visible;margin-top:-5px;"
                  >
                    个人用户请上传手持身份证正面半身照片以及身份证正反面照片，企业用户请上传营业执照扫描件
                  </span>
                </div>

                <div class="row submit-bar">
                  <div class="col-md-12">
                    <div style="display:flex;justify-content:center">
                      <button
                        class="btn-sm btn btn-outline-dark"
                        type="button"
                        @click="toLogin"
                      >
                        取消
                      </button>
                      <button
                        class="btn-sm btn btn-primary"
                        type="button"
                        style="margin-left:10px"
                        @click="submitPreserve"
                      >
                        <span v-if="!index_id">注册</span>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- </b-form> -->

                <!-- <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label>主页封面图</label>
                    <image-upload ref="cover"></image-upload>
                  </div>
                </div>
              </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import Vue from "vue";
// import Swal from "sweetalert2";
import Layout from "@/router/layouts/main";
import imageUpload from "./imageUpload";
import DatePicker from "vue2-datepicker";
import api from "@/server/api/media";
import { getTimeNow, passwordValidate } from "@/util/fun.js";

export default {
  components: {
    Layout,
    DatePicker,
    imageUpload,
  },
  data() {
    return {
      item: {
        userType: "1",
      },
      img1: "",
      img2: "",
      img3: "",
      password: "",
      definePass: "",
      index_id: undefined,
      allModify: false,
      media: {
        name: "",
        phone: "",
        password: "",
        repeatPassword: "",
        cerName: "", //认证名称
        description: "", //媒体号简介
        operateBody: "", //运营主体
        creditCode: "", //统一社会信用代码/身份证号码
        type: 1, //账号类型 1媒体号2商家
        cerType: 1, //认证类型 1个人2企业
        verifyFlag: 0, //免审开关，1开0关
        avatar: "", //头像地址
        photoAddress: "", //材料文件地址
      },
      adminId: undefined,
      isEdit: false,
      form: {},
      validate_name: null,
      validate_phone: null,
      validate_password: null,
      validate_repeatPassword: null,
      validate_cerName: null,
      validate_description: null,
      validate_operateBody: null,
      validate_creditCode: null,
      passwordWarning: "",
      repeatPasswordWarning: "",
    };
  },

  mounted() {
    // this.adminId = JSON.parse(this.cookies.getCookie("user")).id;
    // console.log(this.adminId)
    // if (this.$route.query.id) {
    //   this.isEdit = true;
    //   this.index_id = Number(this.$route.query.id);
    //   this.fetch();
    // }
    // if (this.$route.query.allModify) {
    //   this.allModify = true;
    // }
    setTimeout(() => {
      console.log("执行了");
      let media = this.another(this.media);
      media.phone = "";
      media.password = "";
      this.media = media;
      //   this.media.phone = "";
      //   this.media.password = "";
      this.validate_phone = null;
      this.validate_password = null;
      console.log(this.media.phone);
    }, 1000);
  },

  methods: {
    fetch() {
      var params = {
        id: this.index_id,
      };
      if (this.$route.query.userType) {
        params.userType = this.$route.query.userType;
      }
      api.detail(params).then((resp) => {
        console.log("媒体号详情", resp);
        if (resp.code == 0) {
          let obj = {};
          let item = resp.data;
          obj.name = item.name;
          obj.phone = item.phone;
          obj.cerName = item.cerName;
          obj.description = item.description;
          obj.operateBody = item.operateBody;
          obj.creditCode = item.creditCode;
          this.adminId = item.adminId;
          if (item.type !== undefined) {
            obj.type = item.type;
          }
          if (item.cerType !== undefined) {
            obj.cerType = item.cerType;
          }
          if (item.verifyFlag !== undefined) {
            obj.verifyFlag = item.verifyFlag;
          }
          obj.avatar = item.avatar;
          obj.photoAddress = item.photoAddress;
          if (item.photoAddress) {
            if (item.cerType == 1) {
              let arr = item.photoAddress.split(",");
              this.img1 = arr[1];
              this.img2 = arr[2];
              this.img3 = arr[3];
            } else {
              this.img1 = item.photoAddress;
            }
          }
          this.media = obj;
          // this.item = resp.data;
          // this.item.definePass = this.item.password;
          // this.item.userType = this.item.userType.toString();
          // this.$refs.avatar.setImageUrl(this.item.avatar);
          // this.$refs.cover.setImageUrl(this.item.background)
        }
      });
    },

    submitPreserve() {
      this.validateName();
      this.validatePhone();
      this.validatePassword();
      if (!passwordValidate(this.media.password)) {
        return;
      }
      this.validateRepeatPassword();
      this.validateCerName();
      this.validateDescription();
      this.validateOperateBody();
      this.validateCreditCode();
      console.log("保存参数", this.media, this.img1, this.img2, this.img3);
      let params = this.another(this.media);
      params.verifyState = 3;
      // if(params.name)
      // return;
      // let params = JSON.parse(JSON.stringify(this.item));
      if (params.name) {
        if (params.name.length < 2) {
          this.warning("媒体号名称最少输入2个字符");
          return;
        }
      } else {
        this.warning("请输入媒体号名称");
        return;
      }
      if (!params.phone) {
        this.warning("请输入手机号");
        return;
      } else if (!/^1[3456789]\d{9}$/.test(params.phone)) {
        this.warning("请输入合法的手机号");
        return;
      }
      if (this.index_id) {
        if (params.password) {
          if (params.repeatPassword) {
            if (params.repeatPassword != params.password) {
              this.warning("两次输入密码不一致");
              return;
            }
          } else {
            this.warning("请输入重复密码");
            return;
          }
        } else {
          delete params.password;
        }
        if (params.repeatPassword) {
          if (!params.password) {
            this.warning("请输入密码");
            return;
          }
        }
      } else {
        if (params.password) {
        } else {
          this.warning("请输入密码");
          return;
        }
        if (params.repeatPassword) {
          if (params.repeatPassword != params.password) {
            this.warning("两次输入密码不一致");
            return;
          }
        } else {
          this.warning("请输入确认密码");
          return;
        }
      }
      if (!params.cerName) {
        this.warning("请输入认证名称");
        return;
      }
      if (!params.description) {
        this.warning("请输入媒体号简介");
        return;
      }

      if (!params.operateBody) {
        this.warning("请输入运营主体/姓名");
        return;
      }
      if (!params.creditCode) {
        this.warning("请输入统一社会信用代码/身份证号");
        return;
      }
      if (!params.avatar) {
        this.warning("请上传头像");
        return;
      }
      //   console.log("用户类型", params.cerType, typeof params.cerType);
      if (!params.cerType) {
        this.warning("请选择认证类型");
        return;
      }
      if (!this.img1 && !this.img2 && !this.img3) {
        this.warning("请上传认证材料");
        return;
      }
      /*if (this.img1 == "" || this.img2 == "" || this.img3 == "") {
          this.warning("个人用户请按规则上传三张图片");
          return;
        }
        params.photoAddress = this.img1 + "," + this.img2 + "," + this.img3;*/
      params.photoAddress = "";

      let imgArr = [];
      if (this.img1 != "") {
        imgArr.push(this.img1);
      }
      if (this.img2 != "") {
        imgArr.push(this.img2);
      }
      if (this.img3 != "") {
        imgArr.push(this.img3);
      }
      params.photoAddress = imgArr;

      // params.background = this.$refs.cover.getImageUrl()
      // if(!params.background){
      //   this.warning("请上传主页封面图");
      //   return
      // }
      let msg = "";
      if (this.index_id === undefined) {
        msg = "确认注册？";
      } else {
        msg = "确认保存并提交审核？";
      }
      params.lastChangeTime = getTimeNow(); //密码修改时间
      this.confirm(msg, () => {
        // params.id = this.index_id;
        // params.adminId = this.adminId;
        console.log("保存参数", params);
        api.register(params).then((resp) => {
          // console.log("添加结果", resp);
          if (resp.code === 0) {
            this.success("注册成功！");
            setTimeout(() => {
              window.location.pathname = "/login";
            }, 500);
          } else {
            this.warning(resp.msg);
            console.log(resp);
          }
        });
      });
    },

    goBack() {
      this.$router.go(-1);
    },
    toLogin() {
      this.confirm("确认取消注册？", () => {
        window.location.pathname = "/login";
      });
    },
    validateName() {
      this.validate_name =
        this.media.name.length > 1 && this.media.name.length < 17
          ? null
          : false;
    },
    validatePhone() {
      this.validate_phone = /^1[3456789]\d{9}$/.test(this.media.phone)
        ? null
        : false;
    },
    validatePassword(str) {
      let result = passwordValidate(str, 8);
      if (!result) {
        this.passwordWarning =
          "最低8位，至少1大写字母、1小写字母、1数字、1英文符号";
        this.validate_password = false;
      } else {
        this.passwordWarning = "";
        this.validate_password = null;
      }
    },
    validateRepeatPassword() {
      if (this.media.repeatPassword == "") {
        this.repeatPasswordWarning = "必填项";
      } else {
        this.repeatPasswordWarning = "两次输入的密码不一致";
      }
      this.validate_repeatPassword =
        this.media.repeatPassword == this.media.password &&
        this.media.password != ""
          ? null
          : false;
    },
    validateCerName() {
      this.validate_cerName = this.media.cerName ? null : false;
    },
    validateDescription() {
      this.validate_description = this.media.description ? null : false;
    },
    validateOperateBody() {
      this.validate_operateBody = this.media.operateBody ? null : false;
    },
    validateCreditCode() {
      this.validate_creditCode = this.media.creditCode ? null : false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invalid-feedback {
  position: absolute;
  line-height: 13px;
  font-size: 12px;
}
</style>
